//#endregion
//#region src/index.ts
var e = {
	messages: {
		en: {
			partnersSelector: {
				allPartners: "All partners",
				selectPartner: "Select partner"
			},
			partnerList: {
				active: "Status",
				name: "Search by partner name",
				partnerName: "Partner's name",
				actionsMenu: {
					buttonLabel: "Actions",
					importPartner: "Import partner",
					downloadFeedStatsReport: "Download feed stats report",
					syncAllPartners: "Synchronize all partners",
					back: "Back"
				},
				reportDialog: {
					buttonLabel: "Download feed stats report",
					yearLabel: "Year",
					monthLabel: "Month (1–12)",
					downloadButtonLabel: "Download",
					downloadSuccess: "Feed stats report for {year}-{month} downloaded",
					downloadError: "Failed to download feed stats report"
				},
				importDialog: {
					buttonLabel: "Add partner",
					inputLabel: "Partner reference number",
					importButtonLabel: "Add",
					showCustomPNumberRevShareCheckbox: "Use custom \"pNumberRevShare\" ID",
					customPNumberRevShareInput: "Enter \"pNumberRevShare\" ID",
					customPNumberRevShareTooltipLabel: "Note",
					customPNumberRevShareTooltip: "Should be used only when \"pNumberRevShare\" is not available in Salesforce. The only permitted values are P0000 (for agencies) and P9999 (for internal brands)."
				},
				editPartner: "Edit",
				deletePartner: "Delete",
				detailPartner: "Open",
				stats: "Stats",
				messageDeletePartnerName: "Are you sure you want to delete this partner?",
				messageDeletePartnerCTFOnlyName: "Partner not found in CA. Do you really want to delete it in Vibe?",
				messageDeleted: "Partner deleted",
				messageDeletePartner: "Delete partner",
				errorOnDeleting: "Error deleting partner",
				reloadPage: "Reload page",
				partnerImportSuccess: "Successfully imported partner: {name}"
			},
			partnerEdit: {
				logoLoadError: "Error loading logo",
				requiredFields: "You cannot save the partner because required information is missing.",
				messageSaved: "Partner saved",
				generalTab: "General",
				contractTab: "Contract",
				configTab: "Config",
				generalTabFields: {
					indexContent: "Index auto-published content",
					indexContentBought: "Index bought content",
					name: "Partner name",
					isPartner: "Is Partner",
					account: "Account",
					billingModel: "Billing model",
					pNumberRevShare: "Revenue share partner ID",
					vibeId: "Vibe partner ID",
					partnerId: "Partner reference number",
					pNumberVideo: "Vidoe partner ID",
					pNumberOther: "Other partner ID",
					urlPartner: "Homepage",
					isActiveInCtf: "Active in Vibe",
					isLogoLinkFollow: "Follow tracking in partner links",
					pNumberFixum: "Fixum partner ID",
					urlImprint: "Imprint",
					unpublishAfterDays: {
						label: "Deactivate Content After Days",
						inputLabel: "Number of days"
					},
					unpublishBoughtAfterDays: {
						label: "Deactivate bought content after days",
						inputLabel: "Number of days"
					},
					cooperationHeaderType: {
						label: "Cooperation header type",
						customHeaderInputLabel: "Enter custom header text",
						default: "Default: \"Published in cooperation with\"",
						custom: "Custom",
						customInputLabel: "Custom cooperation text"
					},
					customChannelURL: {
						label: "Use custom channel URL",
						inputLabel: "Enter custom channel URL",
						tooltip: "The custom channel URL will only be used if no render page exists for the specific brand."
					},
					partnerDescriptionLabel: "Partner description",
					billingType: "Billing type"
				},
				contractTabFields: {
					contractModule: "Contract module",
					contractActive: "Contract active",
					contractStart: "Contract start date",
					contractStatus: "Contract status",
					contractType: "Contract type",
					pricePerTextInEuro: "Price per text in Euro",
					contractEnd: "Contract end date",
					contractDeviation: "Contract deviation",
					deviationDistribution: "Distribution notes",
					contentSyndicationNotAllowedOn: "Content syndicatoin not allowed on"
				},
				configTabFields: { renderConfig: {
					renderConfigSectionLabel: "Partner pages render configs",
					tooltipText: "Configuration for partners rendered pages by brand",
					pathLabel: "Render path",
					generateLinkLabel: "Generate render path",
					brandDescription: "Partner description (internal)",
					isPathActive: "Is Render Path Active",
					invalidPathMessage: "Path must be in the format \"/partner/some-string/\"",
					goToPartnerPage: "Go to partner's page",
					isNoIndex: "Activate noIndex",
					metaTitle: "Meta title",
					metaDescription: "Meta description"
				} }
			},
			partnerSync: {
				partnerDataSync: {
					syncPartnerDataLabel: "Synchronize partner data",
					dataSyncSuccess: "Partner data synchronized successfully"
				},
				partnerLogoSync: {
					syncPartnerLogoLabel: "Synchronize partner logo",
					logoSyncSuccess: "Partner logo synchronized successfully"
				},
				allPartnersSync: {
					syncPartners: "Synchronize partners",
					messageSyncPartners: "Are you sure you want to synchronize partners with Salesforce? Existing partners will be updated, missing partners will be added, and the synchronization will run in the background so you can continue using Vibe.",
					messageSyncPartnersName: "Are you sure you want to synchronize partners with Salesforce?",
					messageSyncPartnersStart: "Synchronizing partners. This may take some time."
				}
			},
			partnerTypes: {
				dropdownLabel: "Partner type",
				all: "All",
				contentpartner: "Content partner",
				testpartner: "Test partner",
				bfbrand: "BF Brand",
				agenturen: "Agency",
				spezialpartner: "Special partner"
			},
			activeInVibe: {
				dropdownLabel: "Active in Vibe",
				all: "All",
				true: "Active",
				false: "Inactive"
			},
			feedStatsTab: {
				monthLabel: "Month",
				yearLabel: "Year",
				imported: "Imported",
				published: "Published",
				noData: "No statistics for this period"
			},
			partnerStatsDialog: {
				loadError: "Failed to load feed statistics",
				partnerTotalLabel: "Total",
				partnerNameFilterLabel: "Partner name",
				sortLabel: "Sort by",
				sortByName: "Partner name (A–Z)",
				sortByImported: "Imported (highest first)",
				sortByPublished: "Published (highest first)"
			}
		},
		de: {
			partnersSelector: {
				allPartners: "Alle Partner",
				selectPartner: "Partner wählen"
			},
			partnerList: {
				active: "Status",
				name: "Suchen nach Partner-Name",
				partnerName: "Partner-Name",
				actionsMenu: {
					buttonLabel: "Aktionen",
					importPartner: "Partner importieren",
					downloadFeedStatsReport: "Feed-Statistik-Bericht herunterladen",
					syncAllPartners: "Alle Partner synchronisieren",
					back: "Zurück"
				},
				reportDialog: {
					buttonLabel: "Feed-Statistik-Bericht herunterladen",
					yearLabel: "Jahr",
					monthLabel: "Monat (1–12)",
					downloadButtonLabel: "Herunterladen",
					downloadSuccess: "Feed-Statistik-Bericht für {year}-{month} heruntergeladen",
					downloadError: "Feed-Statistik-Bericht konnte nicht heruntergeladen werden"
				},
				importDialog: {
					buttonLabel: "Partner hinzufügen",
					inputLabel: "Partner-Referenznummer",
					importButtonLabel: "Hinzufügen",
					showCustomPNumberRevShareCheckbox: "\"pNumberRevShare\" eintragen“",
					customPNumberRevShareInput: "\"pNumberRevShare\"-ID eingeben",
					customPNumberRevShareTooltipLabel: "Hinweis",
					customPNumberRevShareTooltip: "Nur nutzen, wenn die \"pNumberRevShare\"-Nummer nicht in Salesforce gelistet ist. Verwendet werden können nur P0000 (für Agenturen) und P9999 (für interne Marken) ."
				},
				editPartner: "Edit",
				deletePartner: "Löschen",
				detailPartner: "Öffnen",
				stats: "Statistik",
				messageDeletePartnerName: "Willst du diesen Partner wirklich löschen?",
				messageDeletePartnerCTFOnlyName: "Partner in CA nicht gefunen. Willst du ihn wirklich in Vibe löschen?",
				messageDeleted: "Partner gelöscht",
				messageDeletePartner: "Partner löschen",
				errorOnDeleting: "Fehler beim Löschen des Partners",
				reloadPage: "Seite neu laden",
				partnerImportSuccess: "Partner erfolgreich importiert: {name}"
			},
			partnerEdit: {
				logoLoadError: "Fehler beim Laden des Logos",
				requiredFields: "Partner kann nicht gespeichert werden, weil Pflichtangaben fehlen.",
				messageSaved: "Partner gespeichert",
				generalTab: "Allgemein",
				contractTab: "Vertrag",
				configTab: "Konfiguration",
				generalTabFields: {
					indexContent: "Indexieren automatisch veröffentlichter Inhalte",
					indexContentBought: "Indexieren gekaufter Inhalte",
					name: "Partner-Name",
					isPartner: "Ist Partner",
					account: "Account",
					billingModel: "Abrechnungsmodell",
					pNumberRevShare: "Revenue-Share-Partner-ID",
					partnerId: "Partner-Referenznummer",
					pNumberVideo: "Video-Partner-ID",
					pNumberOther: "Sonstige Partner-ID",
					vibeId: "Vibe-Partner-ID",
					urlPartner: "Homepage",
					isActiveInCtf: "Aktiv in Vibe",
					isLogoLinkFollow: "Follow-Tracking in Partner-Links",
					pNumberFixum: "Fixum-Partner-ID",
					urlImprint: "Impressum",
					unpublishAfterDays: {
						label: "Inhalte deaktivieren nach x Tagen",
						inputLabel: "Anzahl der Tage"
					},
					unpublishBoughtAfterDays: {
						label: "Gekaufte Inhalte deaktivieren nach x Tagen",
						inputLabel: "Anzahl der Tage"
					},
					cooperationHeaderType: {
						label: "Kooperations-Kopfzeilentyp",
						customHeaderInputLabel: "Eigenen Header-Text eingeben",
						default: "Standard: \"Erschien in Kooperation mit\"",
						custom: "Benutzerdefiniert",
						customInputLabel: "Individueller Kooperationstext"
					},
					customChannelURL: {
						label: "Benutzerdefinierte Channel-URL verwenden",
						inputLabel: "Benutzerdefinierte Channel-URL eingeben",
						tooltip: "Die benutzerdefinierte Channel-URL wird nur verwendet, wenn für die jeweilige Marke keine Rendering-Seite vorhanden ist."
					},
					partnerDescriptionLabel: "Partner-Beschreibung",
					billingType: "Abrechnungsart"
				},
				contractTabFields: {
					contractModule: "Vertragsmodul",
					contractActive: "Vertrag läuft",
					contractStart: "Vertragsbeginn",
					contractStatus: "Vertragsstatus",
					contractType: "Vertragstyp",
					pricePerTextInEuro: "Preis pro Text in Euro",
					contractEnd: "Vertragsende",
					contractDeviation: "Vertragsabweichung",
					deviationDistribution: "Hinweise zur Distribution",
					contentSyndicationNotAllowedOn: "Content-Syndizierung nicht erlaubt auf"
				},
				configTabFields: { renderConfig: {
					renderConfigSectionLabel: "Partner-Seiten-Rendering-Konfiguration",
					tooltipText: "Konfiguration für Partner-Renderings nach Marke",
					pathLabel: "Rendering-Pfad",
					generateLinkLabel: "Rendering-Pfad generieren",
					brandDescription: "Partnerbeschreibung (intern)",
					isPathActive: "Ist Render-Pfad aktiv",
					invalidPathMessage: "Der Pfad muss dem Format \"/partner/some-string/\" entsprechen",
					goToPartnerPage: "Zur Partner-Seite gehen",
					isNoIndex: "NoIndex aktivieren",
					metaTitle: "Meta-Titel",
					metaDescription: "Meta Description"
				} }
			},
			partnerSync: {
				partnerDataSync: {
					syncPartnerDataLabel: "Partner-Daten synchronisieren",
					dataSyncSuccess: "Partner-Daten synchronisiert"
				},
				partnerLogoSync: {
					syncPartnerLogoLabel: "Partner-Logo synchronisieren",
					logoSyncSuccess: "Partner-Logo synchronisiert"
				},
				allPartnersSync: {
					syncPartners: "Partner synchronisieren",
					messageSyncPartners: "Willst du wirklich die Partner mit Salesforce synchronisieren? Bestehende Partner werden aktualisiert, fehlende Partner hinzugefügt und die Synchronisierung läuft im Hintergrund, sodass du Vibe weiterhin nutzen kannst.",
					messageSyncPartnersName: "Willst du wirklich die Partner mit Salesforce synchronisieren?",
					messageSyncPartnersStart: "Partner werden synchronisiert. Dies kann einige Zeit dauern."
				}
			},
			partnerTypes: {
				dropdownLabel: "Partner-Typ",
				all: "All",
				contentpartner: "Content-Partner",
				testpartner: "Test-Partner",
				bfbrand: "BF-Marke",
				agenturen: "Agentur",
				spezialpartner: "Spezieller Partner"
			},
			activeInVibe: {
				dropdownLabel: "Aktiv in Vibe",
				all: "Alle",
				true: "Aktiv",
				false: "Nicht aktiv"
			},
			feedStatsTab: {
				monthLabel: "Monat",
				yearLabel: "Jahr",
				imported: "Importiert",
				published: "Veröffentlicht",
				noData: "Keine Statistik für diesen Zeitraum."
			},
			partnerStatsDialog: {
				loadError: "Feed-Statistik konnte nicht geladen werden",
				partnerTotalLabel: "Gesamt",
				partnerNameFilterLabel: "Partnername",
				sortLabel: "Sortierung",
				sortByName: "Partnername (A–Z)",
				sortByImported: "Importiert (höchste zuerst)",
				sortByPublished: "Veröffentlicht (höchste zuerst)"
			}
		}
	},
	routes: [{
		path: "/partners",
		children: [{
			path: "",
			name: "partner_list",
			component: () => import("./partner-list.view-ChywGiWW.js"),
			meta: { requiredRight: "partners:manage" }
		}, {
			path: ":id",
			name: "partner_edit",
			component: () => import("./partner-edit.view-DWhM_8oH.js"),
			props: (e) => ({
				id: e.params.id,
				backRoute: "/partners",
				tab: e.query.tab
			}),
			meta: { requiredRight: ["partners:manage"] }
		}]
	}]
};
//#endregion
export { e as partnerModule };

//# sourceMappingURL=index.es.js.map